import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SetAvatar from "./components/SetAvatar";
import Chat from "./pages/HomeScreen";
import { ToastContainer } from "react-toastify";
import Navbar from "./components/Navbar";
import AllMessages from "./pages/AllMessages";
import Login from "./pages/Login";
import Protected from "./components/Protected";
import AllReviews from "./pages/AllReviews";

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navbar />}>
            <Route path="/" element={<Chat />} />
          </Route>
          <Route
            path="/all-messages"
            element={
              <Protected>
                <AllMessages />
              </Protected>
            }
          />
          <Route 
            path="/all-reviews"
            element={
              <Protected>
                <AllReviews />
              </Protected>
            }
          />
          {/* </Route> */}
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="bottom-left"
        toastStyle={{ backgroundColor: "black", color: "white" }}
      />
    </>
  );
}
